import { render, staticRenderFns } from "./SimulatorCard.vue?vue&type=template&id=f68429b4&scoped=true"
import script from "./SimulatorCard.vue?vue&type=script&lang=js"
export * from "./SimulatorCard.vue?vue&type=script&lang=js"
import style0 from "./SimulatorCard.vue?vue&type=style&index=0&id=f68429b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f68429b4",
  null
  
)

export default component.exports